<ng-content select="input[type='radio']"></ng-content>
<label for="{{ id }}"><ng-content></ng-content></label>
